export { default } from './PublisherInvitationAccept';
